<div class="column">
    <div class="cell">
        @for (round of penalties[0].penalties; track $index) {
            <div class="round" [class.scored]="round === 'Scored'" [class.missed]="round === 'Missed'"></div>
        }
    </div>
    <div class="cell">
        @for (round of penalties[1].penalties; track $index) {
            <div class="round" [class.scored]="round === 'Scored'" [class.missed]="round === 'Missed'"></div>
        }
    </div>
</div>
<div class="column">
    <div class="cell">{{ score[0] }}</div>
    <div class="cell">{{ score[1] }}</div>
</div>
